import {ViewPopup} from '../ViewPopup'
import {createDivIn, createImgIn, createParagraphIn, createSpanIn, setElementInnerHTML, setElementOnClick} from '../../ui_utils/DomUtils'
import {LobbyImage} from '@colonist/types'
import {UIAPIEndpoints} from '../../network/UIAPIEndpoints'
import {CA} from '../../analytics/Analytics'
import {isMobileLandscapeView, navigateToPage} from '../../ui_utils/ClientUtils'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {clientI18n} from '../../ClientI18n'
import {TranslationArrayKeys} from '@colonist/i18n'
import {StorageWrapper} from '../../StorageWrapper'
import {AudioManager, AudioType} from '@colonist/audio'

export class ViewPopupLogin extends ViewPopup {
    private readonly loginButtonsDiv: HTMLDivElement
    private readonly callbackHash?: string | undefined

    // TODO: This file should not be in memebership_incentive folder. Refactor
    constructor(preventClicksOutsideOfPopupFromClosingPopup: boolean = false, callbackHash?: string) {
        super({key: 'strings:homePage.header.login'}, {key: 'strings:colonistCommon.utils.emptyString'}, () => undefined, () => undefined, true)

        this.preventClicksOutsideOfPopupFromClosingPopup = preventClicksOutsideOfPopupFromClosingPopup
        this.callbackHash = callbackHash ?? ViewPopupLogin.getCallbackHashFromUrl()
        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})

        const shouldMakeLarge = isMobileLandscapeView() || UIUtilsEjsVariables.isUserOnMobileAppOrWeb
        if(shouldMakeLarge) this.makeLarge()

        const loginPerkPopupWrapper = createDivIn(this.body, 'popup-login-wrapper', '')
        const loginPerksDiv = createDivIn(loginPerkPopupWrapper, 'popup-login', '')

        const perkKeys: TranslationArrayKeys[] = ['strings:popups.login.perks.addFriends', 'strings:popups.login.perks.trackStats', 'strings:popups.login.perks.accessMore', 'strings:popups.login.perks.playRanked']

        for(const perkKey of perkKeys) {
            const perkText = clientI18n.tArray(perkKey).join(' ')
            const perkDiv = createDivIn(loginPerksDiv, 'popup-login-perk', '')
            const perkCheckDiv = createDivIn(perkDiv, '', '')
            createImgIn(perkCheckDiv, LobbyImage.CheckMark)
            const perkTextDiv = createDivIn(perkDiv, '', '')
            createParagraphIn(perkTextDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: perkText}}, '', '')
        }

        this.loginButtonsDiv = createDivIn(loginPerkPopupWrapper, 'popup-login-buttons', '')

        this.createLoginButtons()
        this.removeFooter()
        this.show()
    }

    private createLoginButtons() {
        const googleLogin = createDivIn(this.loginButtonsDiv, 'popup-login-btn popup-login-google-btn', '')
        createImgIn(googleLogin, LobbyImage.GoogleIcon)
        createSpanIn(googleLogin, '', {key: 'strings:popups.login.loginWith', options: {context: 'google'}})

        const discordLogin = createDivIn(this.loginButtonsDiv, 'popup-login-btn popup-login-discord-btn', '')
        createImgIn(discordLogin, LobbyImage.DiscordIcon)
        createSpanIn(discordLogin, '', {key: 'strings:popups.login.loginWith', options: {context: 'discord'}})

        const appleLogin = createDivIn(this.loginButtonsDiv, 'popup-login-btn popup-login-apple-btn', '')
        createImgIn(appleLogin, LobbyImage.AppleIcon)
        createSpanIn(appleLogin, '', {key: 'strings:popups.login.loginWith', options: {context: 'apple'}})

        setElementOnClick(googleLogin, ViewPopupLogin.createLoginClickHandler(UIAPIEndpoints.googleAuth(this.callbackHash)))
        setElementOnClick(discordLogin, ViewPopupLogin.createLoginClickHandler(UIAPIEndpoints.discordAuth(this.callbackHash)))
        setElementOnClick(appleLogin, ViewPopupLogin.createLoginClickHandler(UIAPIEndpoints.appleAuth(this.callbackHash)))
    }

    private static getCallbackHashFromUrl(): string | undefined {
        const hash = window.location.hash
        if(!hash) return undefined
        if(hash.length <= 1) return undefined
        return hash.substring(1)
    }

    static createLoginClickHandler(url: string) {
        return () => {
            AudioManager.play(AudioType.Click)
            CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.UserClickedLoginButton)
            CA.sendGoogleAnalyticsEvent(CA.Category.HeaderProfile, CA.Label.HeaderProfileClickedLogin)
            StorageWrapper.clearUserState()
            navigateToPage(url)
        }
    }
}
